import React, { useState } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import Header from '../componentes/Header';
import Footer from '../componentes/Footer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import { motion, AnimatePresence } from 'framer-motion';

// --- DATA EXTRAÍDA ---

const preciosManuales = [
  { rango: "0.50~1.00", techo1_pf: 380, techo2_pf: 530, muro1_pf: 460, muro2_pf: 600, techo1_rf: 520, techo2_rf: 670, muro1_rf: 600, muro2_rf: 750 },
  { rango: "1.01~2.00", techo1_pf: 590, techo2_pf: 730, muro1_pf: 710, muro2_pf: 850, techo1_rf: 860, techo2_rf: 1010, muro1_rf: 980, muro2_rf: 1130 },
  { rango: "2.01~3.00", techo1_pf: 800, techo2_pf: 950, muro1_pf: 960, muro2_pf: 1100, techo1_rf: 1200, techo2_rf: 1350, muro1_rf: 1360, muro2_rf: 1520 },
  { rango: "3.01~4.00", techo1_pf: 1000, techo2_pf: 1150, muro1_pf: 1210, muro2_pf: 1350, techo1_rf: 1550, techo2_rf: 1700, muro1_rf: 1750, muro2_rf: 1900 },
  { rango: "4.01~5.00", techo1_pf: 1220, techo2_pf: 1360, muro1_pf: 1460, muro2_pf: 1600, techo1_rf: 1890, techo2_rf: 2050, muro1_rf: 2130, muro2_rf: 2290 },
  { rango: "5.01~5.80", techo1_pf: 1390, techo2_pf: 1530, muro1_pf: 1670, muro2_pf: 1800, techo1_rf: 2170, techo2_rf: 2330, muro1_rf: 2450, muro2_rf: 2600 },
];

const preciosMotorizados = [
  { rango: "0.50~1.00", techo1_pf: 3700, techo2_pf: 3750, muro1_pf: 3820, muro2_pf: 3870, techo1_rf: 4220, techo2_rf: 4350, muro1_rf: 4440, muro2_rf: 4470 },
  { rango: "1.01~2.00", techo1_pf: 4060, techo2_pf: 4110, muro1_pf: 4190, muro2_pf: 4240, techo1_rf: 4910, techo2_rf: 5040, muro1_rf: 5040, muro2_rf: 5170 },
  { rango: "2.01~3.00", techo1_pf: 4430, techo2_pf: 4480, muro1_pf: 4560, muro2_pf: 4600, techo1_rf: 5600, techo2_rf: 5730, muro1_rf: 5740, muro2_rf: 5860 },
  { rango: "3.01~4.00", techo1_pf: 4790, techo2_pf: 4840, muro1_pf: 4930, muro2_pf: 4980, techo1_rf: 6310, techo2_rf: 6440, muro1_rf: 6460, muro2_rf: 6580 },
  { rango: "4.01~5.00", techo1_pf: 5160, techo2_pf: 5210, muro1_pf: 5300, muro2_pf: 5350, techo1_rf: 7010, techo2_rf: 7140, muro1_rf: 7150, muro2_rf: 7280 },
  { rango: "5.01~5.80", techo1_pf: 5470, techo2_pf: 5520, muro1_pf: 5620, muro2_pf: 5670, techo1_rf: 7590, techo2_rf: 7720, muro1_rf: 7740, muro2_rf: 7870 },
];

const caracteristicasMotor = [
  "Tirar para arrancar",
  "Silencioso",
  "Motor bidireccional",
  "Llegada suave",
  "Velocidad ajustable",
  "Módulo de batería extra",
  "Recordar posición",
  "Memoria y posición"
];

const componentesManuales = [
  { producto: "Riel a techo/muro (Manual) 5.8 m", unidad: "Pieza", precio: 427 },
  { producto: "Soporte muro sencillo", unidad: "Pieza", precio: 37 },
  { producto: "Soporte muro doble", unidad: "Pieza", precio: 62 },
  { producto: "Bastón FV 1.52 m", unidad: "Pieza", precio: 79 },
  { producto: "Carro maestro (Plitz/Ripplefold)", unidad: "Pieza", precio: 38 },
  { producto: "Cinta con broches Ripplefold (11, 16 o 21 cm)", unidad: "Rollo 50m", precio: 882 },
];

const componentesMotorizados = [
  { producto: "Riel cortinero motorizado 5.80 m", unidad: "Pieza", precio: 789 },
  { producto: "Motor cortinero WIFI (enchufable)", unidad: "Pieza", precio: 2192 },
  { producto: "Motor cortinero batería recargable RF", unidad: "Pieza", precio: 3428 },
  { producto: "Control remoto monocanal", unidad: "Pieza", precio: 410 },
  { producto: "Soporte muro sencillo", unidad: "Pieza", precio: 37 },
  { producto: "Soporte muro doble", unidad: "Pieza", precio: 62 },
];

const PaginaCortineros = () => {
  const [tabActivo, setTabActivo] = useState('manuales');
  const [tipoModelo, setTipoModelo] = useState('pf'); 

  const renderTablaPrecios = (datos) => (
    <TablaResponsive>
      <thead>
        <tr>
          <th>Ancho (m)</th>
          <th>Techo (1 Hoja)</th>
          <th>Techo (2 Hojas)</th>
          <th>Muro (1 Hoja)</th>
          <th>Muro (2 Hojas)</th>
        </tr>
      </thead>
      <tbody>
        {datos.map((fila, index) => (
          <tr key={index}>
            <td>{fila.rango}</td>
            <td>${fila[`techo1_${tipoModelo}`]}</td>
            <td>${fila[`techo2_${tipoModelo}`]}</td>
            <td>${fila[`muro1_${tipoModelo}`]}</td>
            <td>${fila[`muro2_${tipoModelo}`]}</td>
          </tr>
        ))}
      </tbody>
    </TablaResponsive>
  );

  const renderTablaComponentes = (datos) => (
    <TablaResponsive>
      <thead>
        <tr>
          <th style={{ textAlign: 'left' }}>Producto</th>
          <th>Unidad</th>
          <th>Precio (MXP)</th>
        </tr>
      </thead>
      <tbody>
        {datos.map((item, index) => (
          <tr key={index}>
            <td style={{ textAlign: 'left' }}>{item.producto}</td>
            <td>{item.unidad}</td>
            <td>${item.precio}</td>
          </tr>
        ))}
      </tbody>
    </TablaResponsive>
  );

  return (
    <>
      <Helmet>
        <title>Cortineros y Componentes | Hi Blinds</title>
        <meta name="description" content="Lista de precios de cortineros armados manuales, motorizados y componentes. Incluye sistemas Plitz Francés y Ripplefold." />
      </Helmet>
      <Header />
      
      <ContenedorPrincipal>
        <Titulo>Cortineros y Componentes</Titulo>
        <BtnVolverAnim Ref="/" />

        <TabContainer>
          <Tab botonActivo={tabActivo === 'manuales'} onClick={() => setTabActivo('manuales')}>Manuales</Tab>
          <Tab botonActivo={tabActivo === 'motorizados'} onClick={() => setTabActivo('motorizados')}>Motorizados</Tab>
          <Tab botonActivo={tabActivo === 'componentes'} onClick={() => setTabActivo('componentes')}>Componentes</Tab>
        </TabContainer>

        <AnimatePresence mode="wait">
          <motion.div
            key={tabActivo}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            {tabActivo !== 'componentes' && (
              <OpcionesModelo>
                <button className={tipoModelo === 'pf' ? 'activo' : ''} onClick={() => setTipoModelo('pf')}>Plitz Francés</button>
                <button className={tipoModelo === 'rf' ? 'activo' : ''} onClick={() => setTipoModelo('rf')}>Ripplefold</button>
              </OpcionesModelo>
            )}

            {tabActivo === 'manuales' && (
              <SeccionContenido>
                <h3>Cortineros Armados Manuales</h3>
                <p className="nota">* Incluye: Bastón(es) de 1.52m / 1.82m y brackets para instalación.</p>
                {renderTablaPrecios(preciosManuales)}
                <small>* IVA Incluido</small>
              </SeccionContenido>
            )}

            {tabActivo === 'motorizados' && (
              <SeccionContenido>
                <h3>Cortineros Armados Motorizados</h3>
                <p className="nota">* Incluye: Brackets, Motor WIFI con control remoto.</p>
                
                <CajaInfoTecnica>
                  <h4>Características y Especificaciones del Motor</h4>
                  <div className="datos-basicos">
                    <span><strong>Torque:</strong> 1.2 Nm</span>
                    <span><strong>Velocidad:</strong> 14 cm/s</span>
                    <span><strong>Voltaje:</strong> 120 V</span>
                    <span><strong>Potencia:</strong> 16 W</span>
                  </div>
                  <GridCaracteristicas>
                    {caracteristicasMotor.map((caract, i) => (
                      <div className="badge-caract" key={i}>✓ {caract}</div>
                    ))}
                  </GridCaracteristicas>
                  <p className="alerta"><strong>Opcional:</strong> Cambio a motor RF de Batería Recargable por +$1,300 MXP.</p>
                </CajaInfoTecnica>

                {renderTablaPrecios(preciosMotorizados)}
                <small>* IVA Incluido</small>
              </SeccionContenido>
            )}

            {tabActivo === 'componentes' && (
              <SeccionContenido>
                <h3>Componentes Manuales</h3>
                {renderTablaComponentes(componentesManuales)}
                
                <h3 style={{ marginTop: '30px' }}>Componentes Motorizados</h3>
                {renderTablaComponentes(componentesMotorizados)}
                
                <small>* IVA Incluido. Precios sujetos a cambio sin previo aviso.</small>
              </SeccionContenido>
            )}
          </motion.div>
        </AnimatePresence>
      </ContenedorPrincipal>
      
      <Footer />
    </>
  );
};

// --- ESTILOS ---

const ContenedorPrincipal = styled.main`
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 70vh;
`;

const Titulo = styled.h1`
  text-align: center;
  color: #010755;
  margin-bottom: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 30px 0;
  flex-wrap: wrap;
`;

const Tab = styled.button`
  background-color: ${({ botonActivo }) => (botonActivo ? '#959cfa' : '#010755')};
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;
  
  &:hover {
    background-color: #959cfa;
  }
`;

const OpcionesModelo = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;

  button {
    background: transparent;
    border: 2px solid #010755;
    color: #010755;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.3s;

    &.activo, &:hover {
      background: #010755;
      color: white;
    }
  }
`;

const SeccionContenido = styled.div`
  background: #ffffff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);

  h3 {
    color: #010755;
    margin-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 5px;
  }

  .nota {
    color: #666;
    font-size: 0.95rem;
    margin-bottom: 20px;
  }

  small {
    display: block;
    margin-top: 15px;
    color: #888;
    text-align: right;
  }
`;

const CajaInfoTecnica = styled.div`
  background: #f8f9ff;
  border-left: 4px solid #959cfa;
  padding: 20px;
  margin-bottom: 25px;
  border-radius: 8px;

  h4 {
    margin-top: 0;
    color: #010755;
    margin-bottom: 15px;
  }

  .datos-basicos {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 15px;
    color: #444;
    font-size: 0.95rem;
  }

  .alerta {
    color: #d9534f;
    font-size: 0.9rem;
    margin-top: 15px;
    margin-bottom: 0;
    background: #ffeeee;
    padding: 8px 12px;
    border-radius: 4px;
    display: inline-block;
  }
`;

const GridCaracteristicas = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  
  .badge-caract {
    background: white;
    border: 1px solid #e0e4ff;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 0.85rem;
    color: #333;
    font-weight: 500;
    display: flex;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  }
`;

const TablaResponsive = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.95rem;

  th, td {
    padding: 12px;
    text-align: center;
    border-bottom: 1px solid #eee;
  }

  th {
    background-color: #010755;
    color: white;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background-color: #fafafa;
  }

  tr:hover {
    background-color: #f1f4ff;
  }

  @media (max-width: 600px) {
    font-size: 0.85rem;
    th, td {
      padding: 8px 4px;
    }
  }
`;

export default PaginaCortineros;